import { useQuery } from "react-query";

import {
  getLocalStorageItem,
  HIGHLIGHTED_APP_LOCATION_VIEW_COUNTS_KEY,
} from "../../helpers/localStorage";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { CRMAppLocationIdentifier } from "../../types/Faq";

export type HighlightedAppLocationViewCounts = Partial<
  Record<CRMAppLocationIdentifier, number>
>;

export const getHighlightedAppLocationViews = (
  options: APQueryOptions = {}
) => {
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["highlighted-app-location-views"],
    queryFn: (): HighlightedAppLocationViewCounts => {
      return (
        (getLocalStorageItem<HighlightedAppLocationViewCounts>(
          HIGHLIGHTED_APP_LOCATION_VIEW_COUNTS_KEY
        ) as HighlightedAppLocationViewCounts) || {}
      );
    },
    enabled: isQueryEnabled(options),
  });
};
